import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGalleriesList } from '../../modules/selectors';
import { multipleWatermarkGalleryUpdate } from '../../modules/actions';
import { useCollectionSettingsFieldUpdate } from './useCollectionSettingsFieldUpdate';
import { getSharedGalleriesWatermarkId } from './galleriesGlobalState';

export const useSettingsGlobalWatermark = () => {
  const dispatch = useDispatch();
  const galleries = useSelector(getGalleriesList);
  const { changeFormHandler } = useCollectionSettingsFieldUpdate();
  const [watermarkModal, changeWatermarkModalState] = useState(false);
  const sharedWatermarkID = getSharedGalleriesWatermarkId(galleries);

  // keep the global switch in sync with the per-album watermarks
  useEffect(() => {
    if (sharedWatermarkID) {
      changeFormHandler('globalWatermarkID', sharedWatermarkID);
    }
  }, [sharedWatermarkID, galleries]); // eslint-disable-line

  const changeWatermark = useCallback(
    (value: string) => {
      changeFormHandler('globalWatermarkID', value);
      dispatch(
        multipleWatermarkGalleryUpdate({
          watermark_id: value
        })
      );
    },
    [dispatch, changeFormHandler]
  );

  const hideWatermarkModal = useCallback(() => changeWatermarkModalState(false), []);
  const showWatermarkModal = useCallback(() => changeWatermarkModalState(true), []);

  // switching ON opens the picker; switching OFF clears the watermark everywhere
  const changeWatermarkToggle = useCallback(
    (value: boolean) => {
      changeWatermarkModalState(value);
      if (!value) {
        changeFormHandler('globalWatermarkID', '');
        dispatch(
          multipleWatermarkGalleryUpdate({
            watermark_id: ''
          })
        );
      }
    },
    [dispatch, changeFormHandler]
  );

  return {
    watermarkModal,
    showWatermarkModal,
    hideWatermarkModal,
    changeWatermark,
    changeWatermarkToggle
  };
};
